import { WelcomePageComponent } from './WelcomePage';
import { connectWelcomePage } from './WelcomePage.connect';

export const WelcomePage = connectWelcomePage(WelcomePageComponent);
